import Check from '../Check';
import Report from '../Report';
import { MessageType } from '../Message';
import type { IMethod } from '../../../stores/model/metamodel/method';

/**
 * Check for duplicate acquired methods
 */
class AcquiredMethodDuplicateCheck extends Check<IMethod> {
  static description = 'Check for duplicate acquired methods';

  check(): Report {
    this.report = new Report();
    const subject = this.element;

    for (const method of subject.ownerObjectType.acquiredMethods) {
      if (
        subject !== method &&
        subject.ownerEventType === method.ownerEventType &&
        subject.viaDependency === method.viaDependency &&
        subject.viaMethod === method.viaMethod
      ) {
        this.report.addMessage(
          MessageType.ERROR,
          `Duplicate acquired method found: ${subject.asString()} and ${method.asString()}`,
          this,
          subject
        );
      }
    }

    if (this.report.isEmpty()) {
      this.report.addMessage(
        MessageType.INFORMATION,
        'No duplicate acquired methods found',
        this,
        subject
      );
    }

    return this.report;
  }
}

export default AcquiredMethodDuplicateCheck;
